import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import Dashboard from './components/Dashboard'
import Type from './components/Type'
import TypeSingle from './components/types/TypeSingle'
import Profile from './components/Profile'
import Login from './Login'
import PaymentHistory from './components/PaymentHistory'
import MisingPage from './components/404'
import RequirdAuth from './components/RequireAuth'
import Layout from './components/Layout'
import Unauthorzied from './components/Unauthorzied'
import PersistLogin from './components/PersistLogin'
import NewPost from './components/dashboard/ADMIN/NewPost';
// import Settings from './components/dashboard/ADMIN/Settings';
import Users from './components/dashboard/ADMIN/Users';
import EditPost from './components/dashboard/ADMIN/EditPost';
import Category from './components/dashboard/ADMIN/Category';
import UsersTrafic from './components/dashboard/ADMIN/UsersTrafic';
import CategoryEdit from './components/dashboard/ADMIN/CategoryEdit';
import UserEdit from './components/dashboard/ADMIN/UserEdit';
import CheckOutSetting from './components/dashboard/ADMIN/CheckOutSetting';
import CheckoutRequest from './components/dashboard/ADMIN/CheckoutRequest';
import PayRequest from './components/dashboard/ADMIN/PayRequest';
import RejectRequest from './components/dashboard/ADMIN/RejectRequest';
import UserTrafficEdit from './components/dashboard/ADMIN/UserTrafficEdit';
import Shop from './components/shop/Shop'
import Payment from './components/payment/Payment'
import Purchased from './components/purchased/Purchased'
import TypeSinglePurchased from './components/types/TypeSinglePurchased'
import Orders from './components/orders/Orders'
import DownloadPage from './components/types/DownloadPage';
import Reports from './components/reports/Reports'

const allowedRole = ['USER', 'ADMIN', 'PRODUCER', 'PUBLISHER', 'BUYER']

function App() {
  return (
    <>
      <Routes>
        <Route element={<PersistLogin />}>
          <Route element={<RequirdAuth allowedRole={allowedRole} />}>
            <Route element={<Layout />}>
              <Route index path='/' element={<Dashboard />} />
              <Route path='type' element={<Navigate to='/type/all' />} />
              <Route path='type/:typeId' element={<Type />} />
              <Route path='type/:typeId/:contentId' element={<TypeSingle />} />
              <Route path='profile' element={<Profile />} />
              <Route
                path='profile/paymenthistory'
                element={<PaymentHistory />}
              />
            </Route>
          </Route>

          <Route element={<RequirdAuth allowedRole={['ADMIN']} />}>
            <Route element={<Layout />}>
              <Route path='newpost' element={<NewPost />} />
              <Route path='type/edit/:postId' element={<EditPost />} />
              <Route path='users' element={<Navigate to='/users/new' />} />
              <Route path='users/new' element={<Users />} />
              <Route path='users/management' element={<UsersTrafic />} />
              <Route exact path='users/:userId' element={<UserEdit />} />
              <Route path='users/:userId/traffic' element={<UserTrafficEdit />} />
              {/* <Route path='settings' element={<Settings />} /> */}
              <Route path='category' element={<Category />} />
              <Route path='category/:catId' element={<CategoryEdit />} />
              <Route path='checkout' element={<Navigate to='/checkout/request' />} />
              <Route path='checkout/setting' element={<CheckOutSetting />} />
              <Route path='checkout/request' element={<CheckoutRequest />} />
              <Route path='checkout/request/:requestId' element={<PayRequest />} />
              <Route path='checkout/request/reject/:rejectId' element={<RejectRequest />} />
            </Route>
          </Route>


          <Route element={<RequirdAuth allowedRole={['BUYER']} />}>
            <Route element={<Layout />}>
              <Route index path='/' element={<Dashboard />} />
              <Route path='purchased' element={<Purchased />} />
              <Route path='purchased/:contentId/:linkId' element={<TypeSinglePurchased />} />
            </Route>
          </Route>

          <Route element={<RequirdAuth allowedRole={['ADMIN', 'PRODUCER', 'PUBLISHER']} />}>
            <Route element={<Layout />}>
              <Route index path='/' element={<Dashboard />} />
              <Route path='orders' element={<Orders />} />
              <Route path='reports' element={<Reports />} />
            </Route>
          </Route>

        </Route>

        <Route path='*' element={<MisingPage />} />
        <Route path='/unauthorzied' element={<Unauthorzied />} />
        <Route path='login' element={<Login />} />

        <Route path='shop/:branchId/:subjectId/:publisherId' element={<Shop />} />
        <Route path='payment/:paymentId' element={<Payment />} />
        <Route path='download/:contentId/:userId/:downloadId' element={<DownloadPage />} />


      </Routes>

      <Outlet />
      <ToastContainer rtl={true} autoClose={1500} theme='colored' position='top-center' />
    </>
  )
}

export default App
